import templateUrl from './onboarding-document-w4-form.component.html';
import "./onboarding-document-w4-form.component.less";

export const OnboardingDocumentW4FormComponent = {
    templateUrl,
    controller: OnboardingDocumentW4FormController,
    controllerAs: "vm",
    bindings: {
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<"
    }
};

function OnboardingDocumentW4FormController(utilityService, onboardingDocumentViewService) {
    'ngInject';
    const vm = this;
    vm.$onInit = function () {
        utilityService.showLoading();

        //onboardingDocumentViewService.initializeSubmissionForm({} as any)
        //    .then(state => {
        //        vm.state = state;
        //    });

    }
}
